export default __webpack_public_path__ + "static/busreisen-c4ea60cabc6461a5e03dc033535160bc.png";